module.exports = __webpack_public_path__ + "img/syx.273ace81.png";